import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

// TODO: DIE! Kill it! Burn it with fire! (no reason to exist)
@Injectable()
export class PathPrefixInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const url = request.url;
    const apiReq = request.clone({ url });
    return next.handle(apiReq);
  }
}
